/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.videoPopup .NewsletterPopup__Close').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const video = btn.closest('.videoPopup')?.querySelector('.popup_video video');
      if (video && !video.paused) {
        video.pause();
      }
    });
  });

  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  
  /* sticky header */
  window.addEventListener('scroll', function () {
    const sticky = document.body;
    const scroll = window.scrollY || window.pageYOffset;
    const header = document.querySelector('.shopify-section--header');
    const headerHeight = header ? header.offsetHeight : 0;

    if (scroll > headerHeight) {
      sticky.classList.add('sticky');
    } else {
      sticky.classList.remove('sticky');
    }
  });
  // Mouse enter on video icon
  document.querySelectorAll('.CollectionItem__Wrapper .CollectionItemHasVideo')
  .forEach(function (el) {
    el.addEventListener('mouseenter', function () {
      const wrapper = el.closest('.CollectionItem__Wrapper');
      if (!wrapper) return;

      const video = wrapper.querySelector('.CollectionItem_video.popup_video');

      if (video) video.style.display = 'block';
      el.style.display = 'none';
    });
  });
  // Click on popup close button
  document.querySelectorAll('.CollectionItem_video.popup_video .CollectionItemPopup__Close')
  .forEach(function (btn) {
    btn.addEventListener('click', function () {
      const popup = btn.closest('.CollectionItem_video.popup_video');
      if (!popup) return;

      const wrapper = popup.closest('.CollectionItem__Wrapper');
      const trigger = wrapper?.querySelector('.CollectionItemHasVideo');

      popup.style.display = 'none';
      if (trigger) trigger.style.display = 'block';
    });
  });
  new Swiper('.collection-slider', {
    loop: true,
    speed: 500,
    slidesPerView: 1.2,
    slidesPerGroup: 1,
    centeredSlides: false,
    loopAdditionalSlides: 4,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    initialSlide: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      767: {
        slidesPerView: 1.2
      },
      991: {
        slidesPerView: 2.2
      },
      1200: {
        slidesPerView: 4.2
      }
    }
  });
  new Swiper('.video_slider', {
    loop: true,
    slidesPerView: 2.6,
    centeredSlides: true,
    breakpoints: {
      1920: {
        slidesPerView: 2.6,
        spaceBetween: 5
      },
      990: {
        slidesPerView: 2.6,
        spaceBetween: 5
      },
      750: {
        slidesPerView: 2.6,
        spaceBetween: 5
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 5
      },
      0: {
        slidesPerView: 1.5,
        spaceBetween: 5
      }
    },
    // autoplay: {
    //   delay: 4000,
    // },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
  document.querySelectorAll('.collapsible-content .accordion summary').forEach(function (summary) {
    summary.addEventListener('click', function (e) {
      // Toggle active classes
      summary.classList.toggle('active');

      const accordion = summary.closest('.accordion');
      if (accordion) {
        accordion.classList.toggle('active');

        // Toggle the content
        const content = accordion.querySelector('.accordion__content');
        if (content) {
          if (content.style.display === 'block') {
            content.style.display = 'none';
          } else {
            content.style.display = 'block';
          }
        }
      }

      // Optional: prevent default toggle if needed
      // e.preventDefault();
    });
  });
  const interval = setInterval(function () {
    // Klaviyo form button
    const klaviyoButtons = document.querySelectorAll('.klaviyo-form-SDSWM5 button.needsclick');

    if (klaviyoButtons.length > 0) {
      klaviyoButtons.forEach(btn => {
        btn.classList.add('Button', 'Button--primary');
        btn.style.display = 'inline-block'; // show the button
      });
      clearInterval(interval);
    } else {
      document.querySelectorAll('.klaviyo-form-SDSWM5 button.needsclick').forEach(btn => {
        btn.style.display = 'none';
      });
    }

    // FF form / seal button
    const ffButtons = document.querySelectorAll('[data-ff-el="root"].ff-668fc747e7f66d444e8ace0f .ff-668fc747e7f66d444e8ace0f__button, .seal-button');

    if (ffButtons.length > 0) {
      ffButtons.forEach(btn => {
        btn.classList.add('Button', 'Button--primary');
      });
      document.querySelectorAll('.seal-button').forEach(btn => {
        btn.style.display = 'inline-block';
      });
      clearInterval(interval);
    } else {
      document.querySelectorAll('.seal-button').forEach(btn => {
        btn.style.display = 'none';
      });
    }

  }, 100);
  const containerToggle = document.querySelector('.page-seasonal #container_toggle');
  if (containerToggle) containerToggle.style.display = 'none';

  // Show addon popup
  document.querySelectorAll('.addon_popup_active').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const popup = document.querySelector('.addon_popup');
      if (popup) popup.style.display = 'block';
    });
  });
  // Hide addon popup
  document.querySelectorAll('.addon_popup_close').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const popup = document.querySelector('.addon_popup');
      if (popup) popup.style.display = 'none';
    });
  });
  /*
  // var quick_interval = setInterval(function() {
  //   var foundWidget = false; 

  //   $('.Grid__Cell').each(function() {
  //     var $this = $(this);
  //     if ($this.find('.ProductItem__Wrapper').hasClass('bundle_product')) {
  //       $this.find('.incubate-collections-add-to-cart-widget.cbb-desktop-view').hide();
  //       $this.find('.bundle_add_to_cart').show();
  //     }

  //     if ($this.find('.incubate-collections-add-to-cart-widget').length > 0) {
  //       foundWidget = true;
  //     }
  //   });

  //   if (foundWidget) {
  //     clearInterval(quick_interval);
  //   }
  // }, 100);

  const quick_interval = setInterval(function() {
    let foundWidget = false;

    document.querySelectorAll('.Grid__Cell').forEach(function(cell) {
      const productWrapper = cell.querySelector('.ProductItem__Wrapper');

      // Check for bundle_product
      if (productWrapper && productWrapper.classList.contains('bundle_product')) {
        const desktopWidget = cell.querySelector('.incubate-collections-add-to-cart-widget.cbb-desktop-view');
        const bundleBtn = cell.querySelector('.bundle_add_to_cart');

        if (desktopWidget) desktopWidget.style.display = 'none';
        if (bundleBtn) bundleBtn.style.display = 'inline-block'; // show
      }

      // Check for any add-to-cart widget
      if (cell.querySelector('.incubate-collections-add-to-cart-widget')) {
        foundWidget = true;
      }
    });

    if (foundWidget) {
      clearInterval(quick_interval);
    }
  }, 100);
  */
});